import { useState } from 'react';
import { useAuth } from '../auth/useAuth';
import { Button, Spinner } from './ui';
import styles from './LoginPage.module.css';

/**
 * Branded login page — Harmony QMS sign-in.
 */
export default function LoginPage() {
  const { login, isLoading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setError(null);
    try {
      await login();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed. Please try again.');
    }
  }

  return (
    <div className={styles.page}>
      <img
        src="/logos/harmony-logo-stacked.png"
        alt="Harmony Homecare"
        className={styles.logo}
      />

      <h1 className={styles.heading}>Harmony QMS</h1>
      <p className={styles.tagline}>Quality Management System</p>

      {isLoading ? (
        <Spinner size="lg" />
      ) : (
        <Button
          variant="primary"
          size="lg"
          onClick={handleSignIn}
        >
          Sign in with Harmony
        </Button>
      )}

      {error && <p className={styles.error}>{error}</p>}

      <span className={styles.footer}>Harmony Homecare</span>
    </div>
  );
}
